<template>
  <div>
    <div ref="toolbar">
      <button class="ql-bold">Bold</button>
      <button class="ql-italic">Italic</button>
      <button class="ql-header" value="1">H1</button>
      <button class="ql-header" value="2">H2</button>
      <button class="ql-header" value="3">H3</button>
      <button class="ql-list" value="bullet"></button>
      <button class="ql-image"></button>
      <select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <button class="ql-embed-soundcloud" ></button>
      <button class="ql-pdf-download">P</button>
      <button class="ql-link"></button>
      <div class="extra-bar">
        <small-button v-on:click="handleSave" :loading="saving">Save</small-button>
        <div class="close-box quill-editor" v-on:click="handleClose"></div>
      </div>
    </div>
    <div ref="quillContainer"></div>
    <transition name="fade">
      <div class="input-panel" v-show="showSoundcloudDialog">
        <div class="close-box small" v-on:click="showSoundcloudDialog = false" />
        <p><strong>Paste Soundcloud embed HTML below:</strong></p>
        <textarea v-model="soundcloudHtml" cols="60" rows="5" placeholder="Soundcloud embed HTML"></textarea>
        <p>
          <small-button v-on:click="handleSoundcloudPaste">Embed</small-button>
        </p>
      </div>
    </transition>
    <transition name="fade">
      <div class="input-panel" v-show="showUrlDialog">
        <div class="close-box small" v-on:click="showUrlDialog = false" />
        <p><strong>Enter the URL of the PDF to link to:</strong></p>
        <input type="text" size="60" placeholder="PDF url" v-model="url" />
        <p>
          <small-button v-on:click="handlePdfLinkReplace">Embed</small-button>
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import Quill from './quill-setup.js'
import 'quill/dist/quill.snow.css'

export default {
  props: {
    value: String,
    saveComplete: Boolean
  },
  data () {
    return {
      quill: {},
      soundcloudHtml: '',
      showSoundcloudDialog: false,
      currentRange: null,
      saving: false,
      url: '',
      showUrlDialog: false
    }
  },

  mounted () {
    let vm = this
    this.quill = new Quill(this.$refs.quillContainer, { theme: 'snow', modules: 
      { 
        toolbar: {
          container: this.$refs.toolbar,
          handlers: {
            'embed-soundcloud': vm.handleSoundcloud,
            'pdf-download': vm.handlePdf
          }
        }
      } 
    })
    this.quill.getHTML = function () {
      return this.root.innerHTML
    }
    this.quill.on("text-change", this.handleTextChange)
    if(this.value) {
      this.quill.root.innerHTML = this.value;
    }
  },
  methods: {
    init: function () {
      if (this.value) this.quill.root.innerHTML = this.value; // Set initial editor content
    },
    handleTextChange () {
      let editorContent = this.quill.getHTML() === "<p><br></p>" ? "" : this.quill.getHTML();
      if(editorContent != this.value) {
        this.$emit("input", editorContent);
      }
    },
    handleSave () {
      let editorContent = this.quill.getHTML() === "<p><br></p>" ? "" : this.quill.getHTML();
      this.$emit('save', editorContent)
      this.saving = true
    },
    handleSoundcloud () {
      this.soundcloudHtml = ''
      this.currentRange = this.quill.getSelection()
      this.showSoundcloudDialog = true
    },
    handleSoundcloudPaste () {
      if(this.soundcloudHtml) {
        try {
          this.quill.clipboard.dangerouslyPasteHTML(this.currentRange.index, this.soundcloudHtml, Quill.sources.USER)
          this.showSoundcloudDialog = false
        }
        catch(err) {
          alert('Unable to insert: ' + err.message)
          console.log(err)
        }
      }
    },
    handlePdf () {
      this.url = ''
      this.showUrlDialog = true
    },
    handlePdfLinkReplace () {
      if(this.url) {
        console.log('formatting url')
        this.quill.format('pdf-download', this.url);
      }
      this.showUrlDialog = false
    },
    handleClose () {
      this.$emit('close')
    }
  },
  watch: {
    value(val) {
      if (val != this.quill.root.innerHTML && !this.quill.hasFocus()) {
        this.quill.root.innerHTML = val;
      }
    },
    saveComplete (val) {
      if( val) {
        this.saving = false
      }
      
    }
  }
}
</script>

<style>

  .ql-snow.ql-toolbar button.ql-size[value="small"] , .ql-snow .ql-toolbar button.ql-size[value="small"]
  {
    background-image:url('../../assets/img/small.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size:contain;
  }
  .extra-bar{
    text-align:right;
    padding-right:30px;
  }
  .close-box.quill-editor{
    width: 16px;
    height:16px;
    top:8px;
    right:8px;
  }
  .soundcloud-icon{
    width:100%;
    height:100%;
    background-image:url('../../assets/img/soundcloud.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size:contain;
    opacity:0.7;
  }

  .soundcloud-icon:hover, .qx-pdf-icon:hover, .ql-snow.ql-toolbar button.ql-size[value="small"]:hover , .ql-snow .ql-toolbar button.ql-size[value="small"]:hover{
    opacity:1.0;
    box-shadow:0 0 3px rgba(0,0,0,0.4);
  }

  .qx-brown-panel {
    width:100%;
    height:100%;
    background-image:url('../../assets/img/brown-panel.svg');
    background-position: center center;
    background-size:contain;
  }

  .qx-brown-panel:hover{
    box-shadow:0 0 3px rgba(0,0,2,0.4);
  }

  .ql-container{
    font-family: gibbs, sans-serif;
    font-size: 16px;
  }

  .qx-pdf-icon{
    width:100%;
    height:100%;
    background-image:url('../../assets/img/pdf.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size:contain;
    opacity:0.7;
  }
</style>
<style scoped>
  .input-panel{
    position:fixed;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    padding:30px;
    border-radius:6px;
    box-shadow:2px 2px 4px #00000044;
    background-color:#fff;
    font-size:14px;
  }
</style>
